'use strict';
const React = require('react');
const {default: CardRewardText, cardNameElement} = require('../i18n/card-display-text');
const {sdkTextElement, sdkMessageElement, localizeSdkElement} = require('../i18n/sdk-text');


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const P = require('./protocol.js');
const {PackagePrice} = require('../i18n/price-components');
const {createPackagePrices, keyFor: priceKey, formatCnyPrice, confirmedPaymentMethods} = require('./package-prices.js');
const PaymentMethodIcons = require('../components/credit-purchase/payment-method-icons').default;
const {subscribeAplusWechatPolicy} = require('../controllers/utilities/aplus-wechat-availability');
const {paymentMethodFamilies} = require('./aplus-wechat-policy');
const {createDeliveryNotice, createRewardDeliveredDialog} = require('./reward-delivery-notice.js');
const {activityPresentation, MAX_REWARD_TITLE, MAX_REWARD_NOTE} = require('./activity-presentation.js');

const {
  createLimitedRenderer
} = require('./limited-packages.js');

const {
  createIntro
} = require('./intro-video.js');

const {
  createOpeningNavigation
} = require('./opening-navigation.js');

const {
  bindMobileLayout
} = require('./mobile-layout.js');

const {
  createPackSession
} = require('./pack-session.js');

const {
  createQuoteIntents
} = require('./quote-intents.js');

const {
  navigateOriginalPayment
} = require('./payment-bridge.js');

const SLOGAN = '卡的最高價值為4600人民幣';
const rewardLabel = value => React.createElement(CardRewardText, {text: typeof value === 'string' ? value.replace(/免費\s*OP\s*幣/g, 'OP 幣') : value});
const deliveryLabel = {
  NOT_STARTED: '尚未領取',
  PENDING: '獎勵處理中',
  PARTIAL: '部分獎勵已送達，其餘處理中',
  GRANTED: '獎勵已送達'
}; // The SDK supplies its existing React instance. No second React/runtime is bundled.

function ownedStyleIds(card, owned) {
  return card.styles.filter(id => owned && owned.styles && /^[1-9][0-9]*$/.test(String(owned.styles[id] || '')));
}
function collectionStyleId(card, owned, preferred) {
  const unlocked = ownedStyleIds(card, owned);
  return unlocked.includes(preferred) ? preferred : unlocked[0] || card.styles[0];
}
function styleNumber(card, id) { return card.styles.indexOf(id) + 1; }

function createComponents(React) {
  const h = React.createElement;
  const catalogPrice = entry => h(PackagePrice, {goldbase:entry && entry.status === 'ready' ? entry.goldbase : null}, formatCnyPrice(entry));
  const renderLimitedPackages = createLimitedRenderer(React);
  const OpCardIntro = createIntro(React);
  const OpeningNavigation = createOpeningNavigation(React);
  const RewardDeliveredDialog = createRewardDeliveredDialog(React);

  function button(label, onClick, disabled, props = {}) {
    return h('button', {
      type: 'button',
      onClick,
      disabled,
      ...props
    }, sdkTextElement(label));
  }

  function OpCardEntrances({
    enabled = false,
    onOpen,
    limitedAvailable = false
  }) {
    return localizeSdkElement(h('nav', {
  className: 'opcards-entries',
  'aria-label': '典藏卡包'
}, button(h(React.Fragment, null, h('strong', null, sdkTextElement('常駐典藏卡包')), h('span', null, sdkTextElement(SLOGAN)), h('small', null, sdkTextElement('2／3／5／10 包'))), () => onOpen('permanent'), !enabled || typeof onOpen !== 'function', {
  className: 'opcards-entry opcards-entry-red'
}), button(h(React.Fragment, null, h('strong', null, sdkTextElement('限時典藏合輯')), h('span', null, sdkTextElement(SLOGAN)), h('small', null, sdkTextElement('Normal／VIP 合併活動 · 逐步購買'))), () => onOpen('limited'), !enabled || !limitedAvailable || typeof onOpen !== 'function', {
  className: 'opcards-entry'
})), {
  "aria-label": ["\u5178\u85CF\u5361\u5305"]
});
  }

  class OpCardHub extends React.Component {
    constructor(props) {
      super(props);

      _defineProperty(this, "returned", e => {
        if (e.persisted) this.refresh();
      });

      _defineProperty(this, "refresh", async () => {
        const runtime = this.props.runtime,
              run = ++this.readGeneration;
        ++this.generation;
        this.resetPrices();

        if (!(runtime === null || runtime === void 0 ? void 0 : runtime.api)) {
          this.setState({
            error: '卡包服務尚未接通。',
            busy: false
          });
          return;
        }

        this.setState({
          busy: true,
          error: '',
          readStatus: {catalogue: 'loading', packs: 'loading', collection: 'loading', activity: 'loading'},
          readErrors: {}
        });
        const current = () => this.alive && run === this.readGeneration;
        let pending = 4;
        const read = async (key, request) => {
          try {
            const value = await request();
            if (!current()) return;
            if (key === 'packs') for (const [name, intent] of this.quoteKeys) {
              if (intent.quoteId && value.items.some(p => p.quoteId === intent.quoteId)) this.quoteKeys.delete(name);
            }
            let initialTab;
            if (key === 'activity' && !this.initialTabChosen) {
              this.initialTabChosen = true;
              initialTab = activityPresentation(value, this.props.activityClock).active ? 'limited' : 'permanent';
            }
            this.setState(state => {
              if (!current()) return null;
              const update = key === 'packs' ? {inventory: value.items, cursor: value.cursor} : {[key]: value};
              if (key === 'activity' && value === null && activityPresentation(state.activity, this.props.activityClock).phase === 'ended') update.activity = state.activity;
              if (initialTab) update.tab = initialTab;
              if (key === 'packs' && state.quote && value.items.some(p => p.quoteId === state.quote.quoteId)) Object.assign(update, {quote: null, selected: null});
              return {...update, readStatus: {...state.readStatus, [key]: 'ready'}};
            });
          } catch (failure) {
            if (current()) this.setState(state => current() ? {
              readStatus: {...state.readStatus, [key]: 'error'},
              readErrors: {...state.readErrors, [key]: failure.message || '未能讀取資料。'}
            } : null);
          } finally {
            pending -= 1;
            if (current() && pending === 0) this.setState({busy: false});
          }
        };
        await Promise.all([
          read('catalogue', () => runtime.api.catalogue()),
          read('packs', () => runtime.api.packs()),
          read('collection', () => runtime.api.collection()),
          read('activity', () => runtime.refreshActivity ? runtime.refreshActivity() : Promise.resolve(null))
        ]);
      });

      _defineProperty(this, "tab", tab => {
        this.initialTabChosen = true;
        ++this.generation;
        this.setState({
          tab,
          page: 'packages',
          selected: null,
          quote: null
        });
      });

      _defineProperty(this, "choose", async sku => {
        const r = this.props.runtime,
              c = this.state.catalogue;
        if (r.readOnly || this.state.busy || !(c === null || c === void 0 ? void 0 : c.purchasingEnabled)) return;
        const run = ++this.generation,
              intents = this.quoteKeys;
        this.setState({
          selected: sku.skuId,
          quote: null,
          busy: true,
          error: ''
        });

        try {
          var _intent;

          let activity = this.state.activity;

          if (sku.kind === 'limited') {
            var _activity;

            activity = r.refreshActivity ? await r.refreshActivity() : null;
            P.check(((_activity = activity) === null || _activity === void 0 ? void 0 : _activity.activityId) && activity.enabled === true && activity.purchasingEnabled === true && activity.nextStep === sku.step && !activity.completed, 'ACTIVITY_STEP_NOT_AVAILABLE');
            if (this.alive && run === this.generation) this.setState({
              activity
            });
          }

          if(r.commerce&&typeof r.commerce.navigateSelection==='function'){
            if(this.alive&&run===this.generation){r.commerce.navigateSelection({skuId:sku.skuId,...(sku.kind==='limited'?{activityId:activity.activityId}:{})});this.setState({busy:false});}
            return;
          }

          const key = sku.skuId + ':' + (sku.kind === 'limited' ? activity.activityId : '');
          let quote = null,
              intent = intents.get(key);

          if ((_intent = intent) === null || _intent === void 0 ? void 0 : _intent.quoteId) {
            const prior = await r.api.getQuote(intent.quoteId);
            P.check(prior.skuId === sku.skuId, 'SAVED_QUOTE_SKU_MISMATCH');
            if (prior.status === 'PAYABLE') quote = prior;else {
              intents.delete(key);
              intent = null;
            }
          } // A limited pending quote may have originated before this local browser session.


          if (!quote && sku.kind === 'limited' && activity.pendingQuoteId) {
            const prior = await r.api.getQuote(activity.pendingQuoteId);
            P.check(prior.skuId === sku.skuId && prior.activityId === activity.activityId && prior.status === 'PAYABLE', 'LIMITED_QUOTE_REQUIRES_REFRESH');
            quote = prior;
          }

          if (!quote) {
            if (!intents.has(key)) intents.set(key, {
              requestId: r.makeRequestId(),
              quoteId: null
            });
            const input = {
              skuId: sku.skuId,
              idempotencyKey: intents.get(key).requestId,
              ...(sku.kind === 'limited' ? {
                activityId: activity.activityId
              } : {})
            };
            quote = await r.api.quote(input);
            intents.set(key, { ...intents.get(key),
              quoteId: quote.quoteId
            });

            if (quote.status !== 'PAYABLE') {
              intents.delete(key);
              P.check(false, 'QUOTE_FINISHED_SELECT_AGAIN');
            }
          }

          const bound = quote.catalogueHash === c.catalogueHash ? c : await r.api.catalogue(quote.catalogueHash);
          const original = bound.packages.find(p => p.skuId === quote.skuId);
          P.check(original && quote.paidPacks === original.paidPacks && quote.giftPacks === original.giftPacks, 'QUOTE_CATALOGUE_MISMATCH');
          if (this.alive && run === this.generation) this.setState({
            quote,
            busy: false
          });
        } catch (e) {
          if (this.alive && run === this.generation) this.setState({
            busy: false,
            error: e.message || '未能確認報價。請重試原選項。'
          });
        }
      });

      _defineProperty(this, "checkout", async () => {
        if (this.props.runtime.readOnly || this.state.busy || !this.state.quote) return;
        this.setState({
          busy: true,
          error: ''
        });

        try {
          await navigateOriginalPayment(this.state.quote, this.props.runtime.payment);
        } catch (e) {
          if (this.alive) this.setState({
            error: e.message || '原付款頁尚未接通。'
          });
        } finally {
          if (this.alive) this.setState({
            busy: false
          });
        }
      });

      _defineProperty(this, "more", async () => {
        if (this.state.busy || !this.state.cursor) return;
        const run = ++this.generation;
        this.setState({
          busy: true
        });

        try {
          const result = await this.props.runtime.api.packs(this.state.cursor);

          if (this.alive && run === this.generation) {
            const ids = new Set(this.state.inventory.map(p => p.packId));
            this.setState({
              inventory: [...this.state.inventory, ...result.items.filter(p => !ids.has(p.packId))],
              cursor: result.cursor,
              busy: false
            });
          }
        } catch (e) {
          if (this.alive && run === this.generation) this.setState({
            error: e.message,
            busy: false
          });
        }
      });

      this.state = {
        catalogue: null,
        prices: {},
        inventory: [],
        cursor: null,
        collection: null,
        page: ['collection', 'inventory'].includes(props.page) ? props.page : 'packages',
        tab: props.tab === 'limited' ? 'limited' : 'permanent',
        selected: null,
        quote: null,
        activity: null,
        readStatus: {catalogue: 'idle', packs: 'idle', collection: 'idle', activity: 'idle'},
        readErrors: {},
        busy: false,
        error: '',
        collectionPage: 0,
        collectionStyles: {},
        inspect: null
      };
      this.generation = 0;
      this.readGeneration = 0;
      this.initialTabChosen = false;
      this.expiredActivityRead = null;
      this.quoteKeys = createQuoteIntents(props.runtime);
    }

    componentDidMount() {
      this.alive = true;
      this.refresh();
      this.unsubscribeWechat = subscribeAplusWechatPolicy(value => {
        if (!this.alive) return;
        const signature = JSON.stringify(value && [value.revision, value.enabled, value.ready, value.configured]);
        if (signature !== this.wechatPolicySignature) {
          this.wechatPolicySignature = signature;
          if (this.packagePrices) this.packagePrices.refresh();
        }
        this.setState(state => ({wechatPolicyRevision: (state.wechatPolicyRevision || 0) + 1}));
      });
      if (typeof window !== 'undefined') window.addEventListener('pageshow', this.returned);
      this.priceVisibility = () => this.syncPrices();
      if (typeof document !== 'undefined') document.addEventListener('visibilitychange', this.priceVisibility);
    }

    componentDidUpdate(prev, previousState) {
      if (prev.runtime !== this.props.runtime) {
        ++this.generation;
        ++this.readGeneration;
        this.initialTabChosen = false;
        this.expiredActivityRead = null;
        this.quoteKeys = createQuoteIntents(this.props.runtime);
        this.setState({
          catalogue: null,
          inventory: [],
          cursor: null,
          collection: null,
          activity: null,
          readStatus: {catalogue: 'idle', packs: 'idle', collection: 'idle', activity: 'idle'},
          readErrors: {},
          quote: null,
          collectionStyles: {},
          inspect: null
        }, () => this.refresh());
      } else if (previousState && (previousState.page !== this.state.page || previousState.tab !== this.state.tab || previousState.catalogue !== this.state.catalogue || previousState.activity !== this.state.activity || previousState.readStatus.catalogue !== this.state.readStatus.catalogue || previousState.readStatus.activity !== this.state.readStatus.activity)) {
        this.syncPrices();
      }
      if (prev.activityClock !== this.props.activityClock) {
        const previous = prev.activityClock && prev.activityClock.activity;
        const current = this.props.activityClock && this.props.activityClock.activity;
        const key = activity => activity ? activity.activityId + ':' + activity.startAt + ':' + activity.endAt : '';
        if (key(previous) !== key(current)) {
          this.syncPrices();
          if (previous || current && this.state.readStatus.activity === 'ready') this.refreshExpiredActivity(key(previous) + '>' + key(current));
        }
      }
    }

    async refreshExpiredActivity(activityId) {
      const runtime = this.props.runtime, run = this.readGeneration;
      if (!this.alive || this.expiredActivityRead === activityId || !runtime.refreshActivity) return;
      this.expiredActivityRead = activityId;
      try {
        const activity = await runtime.refreshActivity();
        if (this.alive && runtime === this.props.runtime && run === this.readGeneration) this.setState(state => ({
          activity: activity || state.activity
        }));
      } catch (error) {
        // Keep the current page and any payment quote. The expired activity is
        // already disabled by the published clock; the user can retry the read.
        if (this.alive && runtime === this.props.runtime && run === this.readGeneration) this.setState(state => ({
          readErrors: {...state.readErrors, activity: error.message || '未能更新活動。'}
        }));
      }
    }

    resetPrices() {
      if (this.packagePrices) this.packagePrices.dispose();
      this.packagePrices = null;
      const runtime = this.props.runtime;
      this.priceRuntime = runtime;
      this.setState({prices: {}});
      if (!runtime || !runtime.commerce || typeof runtime.commerce.offers !== 'function') return;
      this.packagePrices = createPackagePrices({
        readOffers: selection => runtime.pricePreload ? runtime.pricePreload.offers(selection) : runtime.commerce.offers(selection),
        onChange: prices => {if (this.alive && runtime === this.props.runtime) this.setState({prices});}
      });
    }

    syncPrices() {
      const reader = this.packagePrices, s = this.state, r = this.props.runtime;
      if (!reader) return;
      if (r.pricePreload && s.readStatus.activity === 'ready') r.pricePreload.setActivity(s.activity);
      if (!this.alive || r.readOnly || s.page !== 'packages' || s.readStatus.catalogue !== 'ready' || !s.catalogue || !s.catalogue.purchasingEnabled || typeof document !== 'undefined' && document.visibilityState === 'hidden') {
        reader.pause();
        return;
      }
      let selections = [];
      if (s.tab === 'permanent') selections = s.catalogue.packages.filter(p => p.kind === 'permanent').map(p => ({skuId: p.skuId}));
      else if (s.readStatus.activity === 'ready' && activityPresentation(s.activity, this.props.activityClock).active && s.activity.purchasingEnabled === true && !s.activity.completed) {
        selections = s.catalogue.packages.filter(p => p.kind === 'limited' && p.step === s.activity.nextStep).map(p => ({skuId: p.skuId, activityId: s.activity.activityId}));
      }
      reader.show(selections);
    }

    componentWillUnmount() {
      this.alive = false;
      if (this.unsubscribeWechat) this.unsubscribeWechat();
      ++this.generation;
      ++this.readGeneration;
      if (typeof window !== 'undefined') window.removeEventListener('pageshow', this.returned);
      if (typeof document !== 'undefined') document.removeEventListener('visibilitychange', this.priceVisibility);
      if (this.packagePrices) this.packagePrices.dispose();
    }

    paymentMethods(entry, enabled) {
      if (!enabled || this.priceRuntime !== this.props.runtime || this.state.readStatus.catalogue !== 'ready') return null;
      const methods = confirmedPaymentMethods(entry);
      return methods.length ? h('span', {className: 'opcards-package-methods'},
        h(PaymentMethodIcons, {availableMethods: paymentMethodFamilies(methods)})) : null;
    }

    packageScreen() {
      var _s$catalogue, _s$catalogue3;

      const s = this.state,
            r = this.props.runtime;
      if (s.tab === 'limited' && s.catalogue && (s.readStatus.activity === 'ready' || s.activity)) return renderLimitedPackages({
        items: s.catalogue.packages,
        activity: s.activity,
        activityClock: this.props.activityClock,
        readOnly: r.readOnly,
        busy: s.busy,
        quote: s.quote,
        priceLabel: r.commerce && s.activity && s.activity.nextStep >= 1 && s.activity.nextStep <= 6 ? h('span', {className: 'opcards-price-with-methods'},
          catalogPrice(s.prices[priceKey({skuId: 'limited-step-' + s.activity.nextStep, activityId: s.activity.activityId})]),
          this.paymentMethods(s.prices[priceKey({skuId: 'limited-step-' + s.activity.nextStep, activityId: s.activity.activityId})],
            !r.readOnly && s.catalogue.purchasingEnabled && s.readStatus.activity === 'ready' && activityPresentation(s.activity, this.props.activityClock).active && s.activity.purchasingEnabled === true && s.activity.completed === false)) : null,
        slogan: SLOGAN,
        onChoose: this.choose,
        onCheckout: this.checkout,
        onTab: this.tab
      });
      const items = (((_s$catalogue = s.catalogue) === null || _s$catalogue === void 0 ? void 0 : _s$catalogue.packages) || []).filter(p => p.kind === s.tab);
      return h(React.Fragment, null, h('section', {
        className: 'opcards-hero'
      }, h('small', null, s.tab === 'limited' ? sdkTextElement('限時典藏合輯') : sdkTextElement('常駐典藏卡包')), h('h1', null, sdkTextElement(MAX_REWARD_TITLE)), h('p', {className: 'opcards-value-note'}, sdkTextElement(SLOGAN)), h('p', {className: 'opcards-reward-note'}, sdkTextElement(MAX_REWARD_NOTE)), h('p', null, r.readOnly ? r.openingEnabled ? sdkTextElement('卡包尚未開售；已持有的卡包可揭開。') : sdkTextElement('卡包預覽 · 目前尚未開售或開放揭卡。') : sdkTextElement('每包一張典藏卡。付款後保留卡包，完整揭開才領取卡內獎勵。'))), h('div', {
        className: 'opcards-tabs'
      }, button('常駐卡包', () => this.tab('permanent'), s.busy, {
        'aria-pressed': s.tab === 'permanent'
      }), button('限時合輯', () => this.tab('limited'), s.busy, {
        'aria-pressed': s.tab === 'limited'
      })), s.tab === 'limited' && h('p', {
        className: 'opcards-progress'
      }, s.activity ? s.activity.completed ? sdkTextElement('本活動已完成 · 每位玩家限一輪') : sdkMessageElement("\u76EE\u524D\u7B2C {{v0}} \u6B65 \xB7 \u6BCF\u4F4D\u73A9\u5BB6\u6BCF\u6D3B\u52D5\u4E00\u8F2A", {
  v0: s.activity.nextStep
}) : sdkTextElement('活動資料尚未確認，購買暫停。')), h('div', {
        className: 'opcards-package-grid'
      }, !s.catalogue && h('p', {role: 'status'}, s.readStatus.catalogue === 'error' ? sdkTextElement('暫時未能讀取卡包商品，請重新查詢。') : sdkTextElement('正在讀取卡包商品…')), items.map(p => {
        var _s$quote, _s$catalogue2;

        const locked = p.kind === 'limited' && (!s.activity || s.activity.nextStep !== p.step);
        return button(h(React.Fragment, null, h('span', {
          className: 'opcards-foil',
          'aria-hidden': true
        }, 'OP'), h('strong', null, sdkMessageElement("{{v0}} \u5305", {
  v0: p.paidPacks
})), p.giftPacks > 0 && h('b', {
          className: 'opcards-bonus'
        }, sdkMessageElement("\u53E6\u8D08 {{v0}} \u5305", {
  v0: p.giftPacks
})), h('span', null, cardNameElement(p.name)), h('small', {className: 'opcards-package-price', 'aria-live': 'polite'}, r.readOnly ? sdkTextElement('尚未開售') : locked ? sdkTextElement('尚未開放') : r.commerce ? catalogPrice(s.prices[priceKey({
  skuId: p.skuId
})]) : ((_s$quote = s.quote) === null || _s$quote === void 0 ? void 0 : _s$quote.skuId) === p.skuId ? P.money(s.quote.amountMinor, s.quote.currency) : sdkTextElement('選擇後確認價格')), p.kind === 'permanent' && this.paymentMethods(s.prices[priceKey({skuId: p.skuId})],
          !r.readOnly && !!r.commerce && !locked && s.catalogue.purchasingEnabled)), () => this.choose(p), r.readOnly || s.busy || locked || !((_s$catalogue2 = s.catalogue) === null || _s$catalogue2 === void 0 ? void 0 : _s$catalogue2.purchasingEnabled), {
          key: p.skuId,
          className: 'opcards-package',
          'aria-pressed': s.selected === p.skuId
        });
      })), s.catalogue && !((_s$catalogue3 = s.catalogue) === null || _s$catalogue3 === void 0 ? void 0 : _s$catalogue3.purchasingEnabled) && h('p', {
        role: 'status'
      }, sdkTextElement('卡包尚未開放購買。')), s.quote && h('aside', {
        className: 'opcards-quote'
      }, h('strong', null, P.money(s.quote.amountMinor, s.quote.currency)), h('p', null, sdkMessageElement("{{v0}} \u5305{{v1}}\uFF1B\u4E0D\u53E6\u9644\u5373\u6642 OP \u5E63\u3002", {
  v0: s.quote.paidPacks,
  v1: s.quote.giftPacks ? '＋贈 ' + s.quote.giftPacks + ' 包' : ''
})), button('選擇付款方式', this.checkout, s.busy, {
        className: 'opcards-primary'
      }), h('small', null, sdkTextElement('沿用原 SDK 的支付寶／微信／Visa 付款選擇頁。'))));
    }

    inventoryScreen() {
      const s = this.state;
      const openingUnavailable = typeof this.props.onOpenPack !== 'function';
      const retained = s.inventory.filter(p => p.status === 'SEALED' || p.status === 'REVEALED').length;
      return h('section', null, h('h1', null, sdkTextElement('我的卡包')), h('p', null, sdkTextElement('只顯示後端已確認的卡包。付款返回本頁不等於付款成功。')), openingUnavailable && retained > 0 && h('p', {role: 'status'}, sdkMessageElement("\u76EE\u524D\u5DF2\u8F09\u5165 {{v0}} \u500B\u5F85\u958B\u5361\u5305\u3002\u958B\u5361\u529F\u80FD\u5C1A\u672A\u958B\u653E\uFF0C\u5361\u5305\u6703\u4FDD\u7559\u3002", {
  v0: retained
})), s.inventory.length === 0 && h('p', {role: 'status'}, s.readStatus.packs === 'ready' ? this.props.runtime.readOnly ? sdkTextElement('尚未持有卡包。') : sdkTextElement('尚未查到卡包，可重新查詢付款結果。') : s.readStatus.packs === 'error' ? sdkTextElement('暫時未能讀取卡包，請重新查詢。') : sdkTextElement('正在讀取卡包…')), s.inventory.map(p => h('article', {
        key: p.packId,
        className: 'opcards-pack-row'
      }, h('span', {
        className: 'opcards-foil',
        'aria-hidden': true
      }, 'OP'), h('div', null, h('strong', null, p.status === 'OPENED' ? sdkTextElement('已揭曉卡包') : sdkTextElement('待開典藏卡包')), h('p', null, sdkTextElement(deliveryLabel[p.deliveryStatus]))), button(p.status === 'OPENED' ? '查看同一卡片' : openingUnavailable ? '開卡尚未開放' : '慢慢揭開', () => this.props.onOpenPack(p.packId), s.busy || openingUnavailable))), s.cursor && button('載入更多', this.more, s.busy));
    }

    collectionScreen() {
      if (!this.state.catalogue) return h('section', null, h('h1', null, sdkTextElement('典藏圖鑑')), h('p', {role: 'status'}, this.state.readStatus.catalogue === 'error' ? sdkTextElement('暫時未能讀取圖鑑，請重新查詢。') : sdkTextElement('正在讀取圖鑑…')));
      var _s$collection, _s$catalogue4;

      const s = this.state,
            owned = new Map((((_s$collection = s.collection) === null || _s$collection === void 0 ? void 0 : _s$collection.cards) || []).map(c => [c.cardId, c])),
            cards = ((_s$catalogue4 = s.catalogue) === null || _s$catalogue4 === void 0 ? void 0 : _s$catalogue4.cards) || [],
            pages = Math.max(1, Math.ceil(cards.length / 12)),
            ownershipKnown = s.readStatus.collection === 'ready';
      return h('section', null, h('h1', null, sdkTextElement('典藏圖鑑')), h('p', null, sdkTextElement('同一卡片的不同造型合併收藏，獎勵相同。')), !ownershipKnown && h('p', {role: 'status'}, s.readStatus.collection === 'error' ? sdkTextElement('收藏狀態暫時無法確認，請重新查詢。') : sdkTextElement('正在確認收藏狀態…')), h('div', {
        className: 'opcards-collection'
      }, cards.slice(s.collectionPage * 12, s.collectionPage * 12 + 12).map(c => {
        const entry = owned.get(c.cardId),
              has = !!entry && entry.count !== '0' && ownedStyleIds(c, entry).length > 0,
              styleId = collectionStyleId(c, has ? entry : null, s.collectionStyles[c.cardId]),
              style = this.props.runtime.artwork(c.cardId, styleId);
        return h('article', {
          key: c.cardId
        }, button(h(React.Fragment, null, style && h('img', {
          src: style.thumb,
          loading: 'lazy',
          decoding: 'async',
          alt: !ownershipKnown ? '收藏狀態待確認' : has ? c.name + ' · 造型 ' + styleNumber(c, styleId) : '尚未擁有的卡片'
        }), h('span', null, c.cardId)), () => this.setState({
          inspect: {
            card: c,
            owned: entry,
            initialStyleId: styleId
          }
        }), !ownershipKnown || !has, {
          className: 'opcards-collection-card' + (has ? '' : ' unowned'),
          'aria-label': !ownershipKnown ? c.cardId + ' 收藏狀態待確認' : has ? '放大 ' + c.cardId + ' 造型 ' + styleNumber(c, styleId) : c.cardId + ' 尚未擁有'
        }), h('strong', null, cardNameElement(c.name)), has && h('small', {className: 'opcards-collection-style'}, sdkMessageElement("\u9020\u578B {{v0}}", {
  v0: styleNumber(c, styleId)
})), h('small', null, sdkMessageElement("{{v0}} \u7A2E\u9020\u578B", {
  v0: c.styles.length
})), h('p', null, rewardLabel(c.rewardText)));
      })), h('div', {
        className: 'opcards-pagination'
      }, button('上一頁', () => this.setState({
        collectionPage: s.collectionPage - 1
      }), s.collectionPage === 0), h('span', null, "".concat(s.collectionPage + 1, " / ").concat(pages)), button('下一頁', () => this.setState({
        collectionPage: s.collectionPage + 1
      }), s.collectionPage + 1 >= pages)));
    }

    render() {
      const s = this.state;
      return h('main', {
        className: 'opcards-shell'
      }, h('header', null, button('返回', this.props.onBack, !this.props.onBack), h('strong', null, sdkTextElement('OP 典藏卡包')), button('重新查詢', this.refresh, s.busy)), h('nav', {
        className: 'opcards-nav'
      }, [['packages', '卡包'], ['inventory', '我的卡包'], ['collection', '圖鑑']].map(([page, label]) => button(label, () => this.setState({
        page
      }), s.busy, {
        key: page,
        'aria-current': s.page === page ? 'page' : undefined
      }))), Object.keys(s.readErrors).map(key => h('p', {key: 'read-error-' + key, role: 'alert', className: 'opcards-error'}, sdkMessageElement("{{v0}}\u8B80\u53D6\u5931\u6557\uFF0C\u8ACB\u91CD\u65B0\u67E5\u8A62\u3002", {
  v0: {
    catalogue: '卡包商品',
    packs: '卡包清單',
    collection: '收藏狀態',
    activity: '限時活動'
  }[key]
}))), s.error && h('p', {
        role: 'alert',
        className: 'opcards-error'
      }, sdkTextElement(s.error)), s.busy && h('p', {
        role: 'status'
      }, sdkTextElement('正在確認…')), s.page === 'packages' ? h(React.Fragment, null, h(OpCardIntro, {
        scopeKey: this.props.runtime.scopeKey
      }), this.packageScreen()) : s.page === 'inventory' ? this.inventoryScreen() : this.collectionScreen(), s.inspect && h(OpCardOwnedView, {
        runtime: this.props.runtime,
        ...s.inspect,
        onStyleChange: styleId => this.setState(state => ({collectionStyles: {...state.collectionStyles, [s.inspect.card.cardId]: styleId}})),
        onClose: () => this.setState({
          inspect: null
        })
      }));
    }

  }

  class OpCardOwnedView extends React.Component {
    constructor(props) {
      super(props);
      this.styles = ownedStyleIds(props.card, props.owned);
      this.state = {
        styleId: collectionStyleId(props.card, props.owned, props.initialStyleId),
        error: ''
      };
      this.selectStyle = id => {
        if (!this.styles.includes(id) || id === this.state.styleId) return;
        this.setState({styleId: id, error: ''});
        if (this.props.onStyleChange) this.props.onStyleChange(id);
      };
      this.paintGeneration = 0;
      this.disposed = false;
    }

    componentDidMount() {
      var _this$close;

      this.paint();
      this.previousFocus = document.activeElement;
      (_this$close = this.close) === null || _this$close === void 0 ? void 0 : _this$close.focus();
    }

    componentDidUpdate(prev, prevState) {
      if (prevState.styleId !== this.state.styleId) this.paint();
    }

    componentWillUnmount() {
      var _this$paintAbort, _this$view, _this$previousFocus, _this$previousFocus$f;

      this.disposed = true;
      ++this.paintGeneration;
      (_this$paintAbort = this.paintAbort) === null || _this$paintAbort === void 0 ? void 0 : _this$paintAbort.abort();
      (_this$view = this.view) === null || _this$view === void 0 ? void 0 : _this$view.dispose();
      (_this$previousFocus = this.previousFocus) === null || _this$previousFocus === void 0 ? void 0 : (_this$previousFocus$f = _this$previousFocus.focus) === null || _this$previousFocus$f === void 0 ? void 0 : _this$previousFocus$f.call(_this$previousFocus);
    }

    async paint() {
      var _this$paintAbort2, _this$view2;

      (_this$paintAbort2 = this.paintAbort) === null || _this$paintAbort2 === void 0 ? void 0 : _this$paintAbort2.abort();
      (_this$view2 = this.view) === null || _this$view2 === void 0 ? void 0 : _this$view2.dispose();
      this.paintAbort = new AbortController();
      const run = ++this.paintGeneration;

      try {
        const view = await this.props.runtime.visuals.mountOwned({
          canvas: this.canvas,
          card: this.props.card,
          style: this.props.runtime.artwork(this.props.card.cardId, this.state.styleId),
          signal: this.paintAbort.signal,
          isCurrent: () => !this.disposed && run === this.paintGeneration
        });

        if (this.disposed || run !== this.paintGeneration) {
          view.dispose();
          return;
        }

        this.view = view;
      } catch (e) {
        if (!this.disposed && run === this.paintGeneration) this.setState({
          error: e.message
        });
      }
    }

    render() {
      return localizeSdkElement(h('div', {
  role: 'dialog',
  'aria-modal': true,
  'aria-label': '已擁有卡片',
  className: 'opcards-inspect',
  onKeyDown: e => {
    if (e.key === 'Escape') this.props.onClose();
  }
}, button('關閉', this.props.onClose, false, {
  ref: e => this.close = e,
  className: 'opcards-inspect-close'
}), h('canvas', {
  ref: e => this.canvas = e,
  width: 612,
  height: 876,
  'aria-label': this.props.card.name
}), localizeSdkElement(h('section', {
  className: 'opcards-variant-panel',
  'aria-label': '卡片造型'
}, h('div', {
  className: 'opcards-variant-heading'
}, h('strong', null, sdkMessageElement("\u9020\u578B {{v0}}", {
  v0: styleNumber(this.props.card, this.state.styleId)
})), h('small', null, sdkMessageElement("\u5DF2\u64C1\u6709 {{v0}} / {{v1}} \u7A2E", {
  v0: this.styles.length,
  v1: this.props.card.styles.length
}))), this.styles.length > 1 ? localizeSdkElement(h('div', {
  className: 'opcards-variant-chips',
  role: 'group',
  'aria-label': '選擇已擁有造型'
}, this.styles.map(id => {
  const artwork = this.props.runtime.artwork(this.props.card.cardId, id),
        selected = id === this.state.styleId;
  return button(h(React.Fragment, null, artwork && h('img', {
    src: artwork.thumb,
    alt: '',
    loading: 'lazy',
    decoding: 'async'
  }), h('span', null, sdkMessageElement("\u9020\u578B {{v0}}", {
    v0: styleNumber(this.props.card, id)
  }))), () => this.selectStyle(id), false, {
    key: id,
    className: 'opcards-variant-chip' + (selected ? ' selected' : ''),
    'aria-pressed': selected,
    'aria-label': '造型 ' + styleNumber(this.props.card, id)
  });
})), {
  "aria-label": ["\u9078\u64C7\u5DF2\u64C1\u6709\u9020\u578B"]
}) : h('p', {
  className: 'opcards-variant-single'
}, sdkTextElement('已解鎖此造型'))), {
  "aria-label": ["\u5361\u7247\u9020\u578B"]
}), h('p', null, rewardLabel(this.props.card.rewardText)), this.state.error && h('p', {
  role: 'alert'
}, sdkTextElement(this.state.error))), {
  "aria-label": ["\u5DF2\u64C1\u6709\u5361\u7247"]
});
    }

  }

  class OpCardOpening extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        snapshot: null,
        error: '',
        busy: true,
        loadPhase: 'catalogue',
        artworkLoading: false,
        retryKind: null,
        rewardNotice: null
      };
      this.bootGeneration = 0;
      this.bootPending = false;
      this.boot = this.boot.bind(this);
      this.retryLoad = this.retryLoad.bind(this);
    }

    async componentDidMount() {
      this.alive = true;
      if (typeof window !== 'undefined' && this.root && this.stage && this.canvas) this.releaseLayout = bindMobileLayout(window, this.root, this.stage, this.canvas);
      await this.boot();
    }

    componentDidUpdate(previous) {
      if (previous.runtime !== this.props.runtime || previous.packId !== this.props.packId) this.boot(true);
    }

    async boot(force = false) {
      if (!this.alive || this.bootPending && !force) return;
      const run = ++this.bootGeneration, current = () => this.alive && run === this.bootGeneration;
      this.bootPending = true;
      if (this.deliveryNotice) this.deliveryNotice.dispose();
      this.deliveryNotice = null;
      if (this.session) this.session.dispose();
      if (this.surface) this.surface.dispose();
      this.session = null;
      this.surface = null;
      this.setState({snapshot: null, error: '', busy: true, loadPhase: 'catalogue', artworkLoading: false, retryKind: null, rewardNotice: null});
      const r = this.props.runtime;

      try {
        const session = createPackSession({
          api: r.api,
          packId: this.props.packId,
          scopeKey: r.scopeKey,
          storage: r.storage,
          makeRequestId: r.makeRequestId,
          onChange: s => {
            if (current()) {
              this.setState({
                snapshot: s,
                busy: s.busy,
                error: s.error
              });
              if (this.deliveryNotice) this.deliveryNotice.update(s);
              if (this.surface) this.surface.update(s);
            }
          }
        });
        this.session = session;
        this.deliveryNotice = createDeliveryNotice({
          scopeKey: r.scopeKey, packId: this.props.packId, storage: r.storage,
          document: typeof document !== 'undefined' ? document : null,
          reconcile: () => session.reconcile(),
          canNotify: () => current() && this.state.loadPhase === 'ready',
          onNotice: pack => {if (current()) this.setState({rewardNotice: pack});}
        });
        await r.api.catalogue();
        if (!current()) return;
        this.setState({loadPhase: 'vendors'});
        const surface = await r.visuals.mount({
          canvas: this.canvas,
          fxCanvas: this.fxCanvas,
          audioButton: this.audioButton,
          audioStatus: this.audioStatus,
          reduceControl: this.reduceControl,
          resolveOutcome: o => r.resolveOutcome(o),
          onBegin: () => session.beginReveal(),
          onComplete: () => session.open(),
          onLoadState: state => current() && this.setState({
            loadPhase: state.phase,
            artworkLoading: state.loading,
            retryKind: state.phase === 'error' ? 'artwork' : null,
            ...(state.phase === 'ready' ? {error: ''} : {})
          }, () => {if (current() && this.deliveryNotice) this.deliveryNotice.refresh();}),
          onError: e => current() && this.setState({
            error: e.message,
            retryKind: 'artwork',
            artworkLoading: false,
            loadPhase: 'error'
          })
        });

        if (!current()) {
          surface.dispose();
          return;
        }
        this.surface = surface;
        this.setState({pointerFallback: surface.pointerSupported === false, loadPhase: 'pack', artworkLoading: false});
        const loaded = await session.load();
        if (current() && (!loaded.pack || loaded.error)) throw Error(loaded.error || 'PACK_NOT_READY');
      } catch (e) {
        if (current()) this.setState({
          error: e.message,
          busy: false,
          loadPhase: 'error',
          artworkLoading: false,
          retryKind: 'boot'
        });
      } finally {
        if (current()) this.bootPending = false;
      }
    }

    async retryLoad() {
      if (this.state.retryKind === 'boot') return this.boot();
      if (this.state.retryKind === 'artwork' && this.surface) {
        this.setState({error: ''});
        return this.surface.retryArtwork();
      }
    }

    componentWillUnmount() {
      var _this$releaseLayout, _this$session, _this$surface2;

      this.alive = false;
      ++this.bootGeneration;
      if (this.deliveryNotice) this.deliveryNotice.dispose();
      (_this$releaseLayout = this.releaseLayout) === null || _this$releaseLayout === void 0 ? void 0 : _this$releaseLayout.call(this);
      (_this$session = this.session) === null || _this$session === void 0 ? void 0 : _this$session.dispose();
      (_this$surface2 = this.surface) === null || _this$surface2 === void 0 ? void 0 : _this$surface2.dispose();
    }

    render() {
      var _this$state$snapshot, _this$state$snapshot2;

      const p = (_this$state$snapshot = this.state.snapshot) === null || _this$state$snapshot === void 0 ? void 0 : _this$state$snapshot.pack;
      const loading = ['catalogue', 'vendors', 'pack', 'outcome', 'artwork'].includes(this.state.loadPhase);
      const artworkReady = this.state.loadPhase === 'ready';
      const sealed = p && p.status === 'SEALED' && !loading;
      return h('main', {
        className: 'opcards-opening',
        ref: e => this.root = e
      }, h('header', null, button('我的卡包', this.props.onBack, false), h('strong', null, sdkTextElement('OP 典藏卡')), button('♫ 開啟音樂與音效', undefined, false, {
        ref: e => this.audioButton = e,
        'data-audio-control': true,
        'aria-pressed': 'false'
      })), h('span', {
        className: 'opcards-audio-status',
        ref: e => this.audioStatus = e
      }), h('div', {
        className: 'opcards-opening-layout'
      }, h('section', {
        className: 'opcards-stage',
        ref: e => this.stage = e
      }, h('canvas', {
        ref: e => this.canvas = e,
        width: 960,
        height: 1220,
        tabIndex: 0,
        'aria-busy': loading,
        'aria-label': loading ? '正在載入卡牌，準備完成後即可操作。' : this.state.retryKind ? '卡牌暫時未能載入，請使用重試按鈕。' : sealed ? '觸碰卡牌開始；準備好卡面後可慢慢揭開。' : '按住任意位置向任何方向慢慢揭開；放手停住，反向蓋回。Enter 完整揭開。'
      }), loading && h('div', {className: 'opcards-card-loading', role: 'status', 'aria-live': 'polite'},
        h('strong', null, sdkTextElement('正在載入卡牌…')),
        localizeSdkElement(h('span', {
  className: 'opcards-loading-track',
  role: 'progressbar',
  'aria-label': '正在載入卡牌'
}, h('i', null)), {
  "aria-label": ["\u6B63\u5728\u8F09\u5165\u5361\u724C"]
}),
        h('small', null, sdkTextElement('卡面準備好後即可慢慢揭開，請稍候。'))),
      sealed && h('div', {className: 'opcards-card-start', 'aria-hidden': true}, h('strong', null, sdkTextElement('觸碰卡牌開始')), h('small', null, sdkTextElement('先準備卡面，再慢慢揭開')))), h('section', {
        className: 'opcards-opening-controls'
      }, h('h1', null, (p === null || p === void 0 ? void 0 : p.status) === 'OPENED' ? sdkTextElement('你的典藏卡') : sdkTextElement('慢慢揭開，屬於你的卡')), h('p', null, loading ? sdkTextElement('正在準備原定卡面…') : this.state.pointerFallback ? sdkTextElement('此瀏覽器請使用下方按鈕揭開；原卡包不會改變。') : sealed ? sdkTextElement('觸碰卡牌開始') : artworkReady ? sdkTextElement('上下左右・四角皆可') : sdkTextElement('請重試載入原定卡面。')), (p === null || p === void 0 ? void 0 : p.status) === 'OPENED' && h('div', {
        className: 'opcards-prize',
        role: 'status',
        'aria-live': 'polite'
      }, h('strong', null, sdkTextElement('本卡獎勵')), h('p', null, rewardLabel(this.props.runtime.describeReward(p.outcome))), h('span', null, sdkTextElement(deliveryLabel[p.deliveryStatus])), p.deliveryStatus !== 'GRANTED' && h('small', {className:'opcards-delivery-wait'}, sdkTextElement('正在派送獎勵，完成後會在本頁通知你。'))), p && p.status === 'OPENED' && p.deliveryStatus !== 'GRANTED' && button('重新查詢獎勵狀態', () => this.session && this.session.reconcile(), this.state.busy), button((p === null || p === void 0 ? void 0 : p.status) === 'OPENED' ? '重播同一卡片效果' : '一次剝開', () => {
        var _this$surface3;

        return (_this$surface3 = this.surface) === null || _this$surface3 === void 0 ? void 0 : _this$surface3.openExplicit();
      }, this.state.busy || loading || !p || this.state.retryKind !== null, {
        className: 'opcards-primary'
      }), (p === null || p === void 0 ? void 0 : p.status) === 'OPENED' ? h(OpeningNavigation, {
        runtime: this.props.runtime,
        currentPackId: this.props.packId,
        onOpenPack: this.props.onOpenPack,
        onPackages: this.props.onPackages
      }) : button('重新查詢同一卡包', () => {
        var _this$session2;

        return (_this$session2 = this.session) === null || _this$session2 === void 0 ? void 0 : _this$session2.reconcile();
      }, this.state.busy || !p), this.state.retryKind && button(this.state.retryKind === 'boot' ? '重試載入同一卡包' : '重新載入原定卡面', this.retryLoad, loading || this.state.busy), ((_this$state$snapshot2 = this.state.snapshot) === null || _this$state$snapshot2 === void 0 ? void 0 : _this$state$snapshot2.uncertain) && button('重試原開卡要求', () => {
        var _this$session3;

        return (_this$session3 = this.session) === null || _this$session3 === void 0 ? void 0 : _this$session3.open();
      }, this.state.busy || (p === null || p === void 0 ? void 0 : p.status) !== 'REVEALED'), h('label', null, h('input', {
        type: 'checkbox',
        ref: e => this.reduceControl = e
      }), sdkTextElement(' 減少動態')), this.state.error && h('p', {
        role: 'alert'
      }, this.state.retryKind ? sdkTextElement('卡牌暫時未能載入，請檢查連線後重試。原卡包及獎勵不會改變。') : sdkTextElement(this.state.error)), this.state.busy && h('p', {
        role: 'status'
      }, sdkTextElement('正在確認原卡包…')))), h('canvas', {
        ref: e => this.fxCanvas = e,
        'aria-hidden': true,
        className: 'opcards-fx'
      }), this.state.rewardNotice && artworkReady && h(RewardDeliveredDialog, {
        reward: rewardLabel(this.props.runtime.describeReward(this.state.rewardNotice.outcome)),
        onClose: () => this.setState({rewardNotice: null})
      }));
    }

  }

  function OpCardPaymentReturn({
    onInventory
  }) {
    return h('aside', {
      className: 'opcards-return'
    }, h('strong', null, sdkTextElement('查看我的卡包')), h('p', null, sdkTextElement('由伺服器確認付款及卡包入庫狀態；本頁不觸發付款或補發。')), button('前往我的卡包', onInventory, typeof onInventory !== 'function'));
  }

  return {
    OpCardEntrances,
    OpCardHub,
    OpCardOpening,
    OpCardOwnedView,
    OpCardPaymentReturn
  };
}

module.exports = {
  createComponents,
  SLOGAN,
  deliveryLabel,
  ownedStyleIds,
  collectionStyleId,
  styleNumber
};
